
import Vue from 'vue';
import { Modal, ModalActions, ModalTitle, Button } from '@descomplica/vue-components';
import { ENDPOINTS } from '@/settings/endpoints';
import { CourseModel } from '@descomplica/dex-models';
import { getCourseCategory } from '@/helpers/category';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';

export default Vue.extend({
  components: {
    Modal,
    ModalTitle,
    ModalActions,
    Button,
  },
  props: {
    showInvalidNameModal: {
      required: false,
      type: Boolean,
    },
  },
  computed: {
    alumniProfileEditorRoute(): string {
      return `${ENDPOINTS.alumni}/editar`;
    },
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
  },
  watch: {
    showInvalidNameModal(value: boolean) {
      if (value) {
        Analytics.trackEvent(EVENT_LABELS.modalViewed, {
          course: this.currentCourse.name,
          postgrad_microcertificate_invalid_name_modal: true,
        });
      }
    },
  },
  methods: {
    closeInvalidNameModal(): void {
      this.trackModalInteraction('close');
      this.$emit('onClose');
    },
    redirectToAlumni() {
      this.trackModalInteraction('update_profile');
      window.open(this.alumniProfileEditorRoute, '_blank');
      this.closeInvalidNameModal();
    },
    closeModal() {
      this.trackModalInteraction('download_later');
      this.closeInvalidNameModal();
    },
    trackModalInteraction(action: 'update_profile' | 'download_later' | 'close'): void {
      Analytics.trackEvent(EVENT_LABELS.buttonClicked, {
        in_postgrad_microcertificate_invalid_name_modal: true,
        postgrad_microcertificate_invalid_name_modal_action: action,
        course: this.currentCourse.name,
        category: getCourseCategory(this.currentCourse),
      });
    },
  },
});
